<template>
  <div class="role-manage">
    <div class="role-list">
      <Menu>
        <MenuItem>
          <Button type="primary" style="width: 100%" icon="ios-add">添加角色</Button>
        </MenuItem>
        <MenuItem name="2-1">角色1</MenuItem>
        <MenuItem name="2-2">角色2</MenuItem>
      </Menu>
    </div>
    <div class="form">
      <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
        <FormItem label="角色名称" prop="title">
          <Input v-model="form.title" placeholder="请输入角色名称" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="角色icon" prop="status">
          <upload-file-one @on-success="uploadSuc($event, 1)" :defaultUrl="form.logo" tips=""></upload-file-one>
        </FormItem>
        <FormItem label="角色说明" prop="status">
          <Input type="textarea" v-model="form.title" placeholder="请输入角色名称" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="form.status">
            <Radio label="1">有效</Radio>
            <Radio label="0">无效</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="功能权限">
          <Tree  show-checkbox></Tree>
        </FormItem>
        <FormItem>
          <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
  import UploadFileOne from '_c/upload-custom/upload-file-one'
  export default {
    name: 'role-manage',
    components: {
      UploadFileOne,
    },
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          title: '',
          status: '',
        },
        diyData: {
          rules: {
            title: [
              {
                required: true,
                message: '标题不能为空',
                trigger: 'blur',
              },
            ],
            status: [
              {
                required: true,
                message: '状态不能为空',
                trigger: 'change',
              },
            ],
          },
        },
        apiData: {},
      }
    },
    methods: {
      // 文件上传成功
      uploadSuc() {},
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            const opt = { ...this.form }
            if (this.query.id) {
              opt.id = this.query.id
            } else {
            }
          }
        })
      },
    },
    mounted() {},
  }
</script>

<style scoped lang="less">
  .role-manage {
    display: flex;
    justify-content: left;
    .role-list {
      width: 250px;
    }
    .form {
      flex: 1;
    }
  }
</style>
